export const SUBMITTED_FORMS_VIEW = 'all-submitted-forms';
export const HAZARDS_CONTROL_VIEW = 'hazards-and-control';

export const SUBMITTED_AND_HAZARDS_SECTION = {
  label: 'All Submitted Forms',
  cards: [
    {
      id: SUBMITTED_FORMS_VIEW,
      title: 'All Submitted Forms',
      description: 'View submitted form PDFs.',
      icon: '📁',
    },
    {
      id: HAZARDS_CONTROL_VIEW,
      title: 'Hazards and Control',
      description: 'Log site hazards, photos, and controls by date.',
      icon: '⚠️',
    },
  ],
};
